import axios from 'api';
import history from '@history';
import _ from '@lodash';
import jwtService from 'app/services/jwtService';
import * as MessageActions from 'app/store/actions/fuse/message.actions';
import * as FuseActions from 'app/store/actions/fuse';
import * as userActions from 'app/auth/store/actions';
import { getCurrentApiUrl } from 'app/helpers';
import { showMessage } from 'app/store/actions/fuse';
// import * as ActionsSalons from './ hairdresser/store/actions';
import * as ActionsSalons from 'app/main/pages/hairdresser/store/actions';
import * as DashboardsSalons from 'app/main/pages/dashboard/store/actions';
import { UserService } from 'app/services/userService';

export const SET_USER_DATA = '[USER] SET DATA';
export const REMOVE_USER_DATA = '[USER] REMOVE DATA';
export const USER_LOGGED_OUT = '[USER] LOGGED OUT';
export const GET_SWITCHED_USER = '[USER] GET SWITCHED USER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export function switchUser(owner, user) {
  const switchedUser = axios.post(`${getCurrentApiUrl()}/user/switch`, {
    owner: {
      id: owner.id ? owner.id : null,
      username: owner.username ? owner.username : null,
      code: owner.code ? owner.code : null
    }
  });

  return dispatch =>
    switchedUser.then(res => {
      if (res.data) {
        user.access_token = localStorage.getItem('jwt_access_token');
        localStorage.setItem('owner', JSON.stringify(user));
        jwtService.setSession(res.data.access_token);
        dispatch(userActions.setUserData(res.data.user));

        // reset store data for the new user
        dispatch(ActionsSalons.resetHairdressers());
        dispatch(DashboardsSalons.resetDashboardSlides());
        dispatch(DashboardsSalons.resetDashboardPress());
        dispatch(DashboardsSalons.resetDashboardNews());

        history.push('/dashboard');
        document.location.reload();
        return dispatch(showMessage({ message: 'Connexion réussi' }));
      }
      jwtService.setSession(null);
    });
}

/**
 * Set User Data
 */
export function setUserData(user) {
  return dispatch => {
    /*
        You can redirect the logged-in user to a specific route depending on his role
         */

    if (user.hairdresserId)
      history.location.state = {
        redirectUrl: `/hairdresser/minisite/${user.hairdresserId}?tab=parameters`
      };

    /*
        Set User Settings
		*/
    dispatch(FuseActions.setDefaultSettings(user));

    localStorage.setItem('user', JSON.stringify(user));

    /*
        Set User Data
         */
    dispatch({
      type: SET_USER_DATA,
      payload: user
    });
  };
}

/**
 * Update User Settings
 */
export function updateUserSettings(settings) {
  return (dispatch, getState) => {
    const oldUser = getState().auth.user;
    const user = _.merge({}, oldUser, { data: { settings } });

    updateUserData(user, dispatch);

    return dispatch(setUserData(user));
  };
}

/**
 * Update User Shortcuts
 */
export function updateUserShortcuts(shortcuts) {
  return (dispatch, getState) => {
    const { user } = getState().auth;
    const newUser = {
      ...user,
      data: {
        ...user.data,
        shortcuts
      }
    };

    updateUserData(newUser, dispatch);

    return dispatch(setUserData(newUser));
  };
}

/**
 * Remove User Data
 */
export function removeUserData() {
  localStorage.removeItem('user');

  return {
    type: REMOVE_USER_DATA
  };
}

/**
 * Logout
 */
export function logoutUser() {
  return (dispatch, getState) => {
    const { user } = getState().auth;

    if (!user.role || user.role.length === 0) {
      // is guest
      return null;
    }

    history.push({
      pathname: '/'
    });

    jwtService.logout();

    dispatch(FuseActions.setInitialSettings());

    localStorage.removeItem('user');

    return dispatch({
      type: USER_LOGGED_OUT
    });
  };
}

/**
 * Update User Data
 */
function updateUserData(user, dispatch) {
  if (!user.role || user.role.length === 0) {
    // is guest
    return;
  }

  jwtService
    .updateUserData(user)
    .then(() => {
      dispatch(
        MessageActions.showMessage({ message: 'User data saved with api' })
      );
    })
    .catch(error => {
      dispatch(MessageActions.showMessage({ message: error.message }));
    });
}
